import { Button } from "@controls";
import { DashboardAndPenguin } from "@illustrations";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useOrganizationHasFeature } from "../../hooks/organizations";
import { useMemberPath } from "../../hooks/use-member-path";
import { FeatureSlug } from "../../models/organization";
import { BILLING_PLANS_PATH } from "../../modules/settings/router/paths";

interface FeatureBlockProps {
  feature: FeatureSlug;
  children: React.ReactNode;
}

export default function FeatureBlock({ feature, children }: FeatureBlockProps) {
  const organizationHasFeature = useOrganizationHasFeature(feature);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { settingsPath } = useMemberPath();

  if (organizationHasFeature) {
    return <>{children}</>;
  }

  return (
    <div className="w-full h-full flex flex-col justify-center items-center gap-4">
      <div className="w-full max-w-[450px] mx-2">
        <DashboardAndPenguin />
      </div>
      <p className="text-primary-500 max-w-[400px] text-xl text-center">
        {t("featureNotAvailable")}
      </p>
      <Button
        type="button"
        contained
        onClick={() => navigate(settingsPath(BILLING_PLANS_PATH()))}
      >
        {t("featureNotAvailableUpgradeCta")}
      </Button>
    </div>
  );
}
